function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 4.922c0-1.268 1.323-2.297 2.953-2.297h21.094c1.63 0 2.953 1.029 2.953 2.297v11.156c0 .61-.311 1.194-.865 1.624-.554.431-1.305.673-2.088.673H2.953c-.783 0-1.534-.242-2.088-.673C.31 17.272 0 16.687 0 16.078V4.922zm2.953-.328a.49.49 0 00-.298.096.296.296 0 00-.124.232v11.156c0 .181.19.328.422.328h21.094a.49.49 0 00.298-.096.296.296 0 00.124-.232V4.922a.297.297 0 00-.124-.232.49.49 0 00-.298-.096H2.953zm2.953 3.61c0-.262.134-.512.37-.697.238-.185.56-.288.896-.288h11.812c.336 0 .658.103.895.288.238.185.371.435.371.696 0 .261-.133.512-.37.696-.238.185-.56.289-.896.289H7.172c-.336 0-.658-.104-.895-.289-.237-.184-.37-.435-.37-.696zm1.266 2.952c-.336 0-.658.104-.895.289-.237.184-.37.435-.37.696 0 .26.133.511.37.696.237.184.56.288.895.288h6.75c.335 0 .657-.104.895-.288.237-.185.37-.435.37-.696 0-.261-.133-.512-.37-.696a1.469 1.469 0 00-.895-.289h-6.75z",
  fill: "#36458F"
});

function SvgCardLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardLogo);
export default __webpack_public_path__ + "static/media/card-logo.87d0f3af.svg";
export { ForwardRef as ReactComponent };